// assets/gtm-utils.js
(() => {
  function buildGtmEcommerceEvent(cartData, eventName) {
    if (!cartData || typeof cartData !== 'object') {
      console.error('[GTM] buildGtmEcommerceEvent: cartData is missing or not an object →', cartData);
      return null;
    }

    if (!eventName) {
      console.error('[GTM] buildGtmEcommerceEvent: eventName is missing');
      return null;
    }

    const {
      product_title,
      variant_title,
      vendor,
      product_type,
      properties,
      sku,
      product_id,
      variant_id,
      final_price,
      quantity,
      selling_plan,
      barcode,
    } = cartData;

    const gtmItem = {
      item_id: String(variant_id),
      item_name: `${product_title} - ${variant_title}`,
      item_brand: vendor,
      item_category: product_type || 'Other',
      item_category2: '',
      item_variant: variant_title,
      item_properties: properties || {},
      sku,
      shopifyID: product_id,
      subscriptionID: selling_plan ? variant_id : null,
      onetimeID: selling_plan ? null : variant_id,
      price: (final_price / 100).toFixed(2),
      affiliation: selling_plan ? 'Subscription' : 'One-Time',
      upc: barcode || '',
      quantity,
    };

    const currency =
      (window.Shopify &&
        Shopify.currency &&
        Shopify.currency.active) || 'USD';

    return {
      event: eventName,
      ecommerce: {
        currency,
        items: [gtmItem],
      },
    };
  }

  function mapCartLineToGtmItem(line) {
    const {
      product_title,
      variant_title,
      vendor,
      product_type,
      properties,
      sku,
      product_id,
      variant_id,
      final_price,
      price,
      quantity,
      selling_plan,
      selling_plan_allocation,
      barcode,
    } = line;

    const cents = typeof final_price === 'number' ? final_price : price;

    const isSubscription = !!selling_plan ||
      !!selling_plan_allocation?.selling_plan ||
      /subscription/i.test(variant_title);

    const affiliation = isSubscription ? 'Subscription' : 'One-Time';
    const subscriptionID = isSubscription ? variant_id : null;
    const onetimeID = isSubscription ? null : variant_id;

    return {
      item_id: String(variant_id),
      item_name: `${product_title} - ${variant_title}`,
      item_brand: vendor,
      item_category: product_type || 'Other',
      item_category2: '',
      item_variant: variant_title,
      item_properties: properties || {},
      sku,
      shopifyID: product_id,
      price: (cents / 100).toFixed(2),
      upc: barcode || '',
      quantity,
      affiliation,
      subscriptionID,
      onetimeID,
    };
  }


  function buildGtmCartEvent(cartData, eventName) {
    if (!cartData || !Array.isArray(cartData.items)) {
      console.error('[GTM] buildGtmCartEvent: invalid cartData →', cartData);
      return null;
    }

    if (!eventName) {
      console.error('[GTM] buildGtmCartEvent: eventName is missing');
      return null;
    }

    const currency = (window.Shopify?.currency?.active) || cartData.currency || 'USD';

    return {
      event: eventName,
      ecommerce: {
        currency,
        items: cartData.items.map(mapCartLineToGtmItem),
      },
    };
  }


  function pushToDataLayer(payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    console.log(`[GTM] ${payload.event} pushed ➜`, payload.ecommerce.items);
    console.log('window.dataLayer', window.dataLayer);
  }

  function mapRemovedLineToGtmItem(removedLine) {
    const {
      title,
      product_title,
      variant_title,
      vendor,
      product_type,
      sku,
      product_id,
      variant_id,
      price,
      quantity,
    } = removedLine;

    const priceString = typeof price === 'number' ? (price / 100).toFixed(2) : price;
    const isSubscription = /^subscription/i.test(variant_title || '');
    const affiliation = isSubscription ? 'Subscription' : 'One-Time';
    const subscriptionID = isSubscription ? variant_id : null;
    const onetimeID = isSubscription ? null : variant_id;
    const itemName = title || product_title || '';

    return {
      item_id: String(variant_id),
      item_name: itemName,
      item_brand: vendor,
      item_category: product_type || 'Other',
      item_category2: '',
      item_variant: variant_title,
      sku,
      shopifyID: product_id,
      price: priceString,
      upc: '',
      quantity,
      affiliation,
      subscriptionID,
      onetimeID,
    };
  }

  function buildGtmRemoveFromCartEvent(itemsRemoved, currency = 'USD') {
    if (!Array.isArray(itemsRemoved) || !itemsRemoved.length) {
      console.error('[GTM] buildGtmRemoveFromCartEvent: itemsRemoved empty →', itemsRemoved);
      return null;
    }

    return {
      event: 'remove_from_cart',
      ecommerce: {
        currency,
        items: itemsRemoved.map(mapRemovedLineToGtmItem),
      },
    };
  }

  function mapAddedLineToGtmItem(addedLine) {
    const {
      title,
      product_title,
      variant_title,
      vendor,
      product_type,
      sku,
      product_id,
      variant_id,
      price,
      quantity
    } = addedLine;

    const priceString = typeof price === 'string'
      ? parseFloat(price).toFixed(2)
      : (price / 100).toFixed(2);

    const isSubscription = /^subscription/i.test(variant_title || title || '');
    const affiliation = isSubscription ? 'Subscription' : 'One-Time';

    return {
      item_id: String(variant_id),
      item_name: title || product_title || '',
      item_brand: vendor,
      item_category: product_type || 'Other',
      item_category2: '',
      item_variant: variant_title,
      sku,
      shopifyID: product_id,
      price: priceString,
      quantity,
      affiliation,
      subscriptionID: isSubscription ? variant_id : null,
      onetimeID: isSubscription ? null : variant_id,
      upc: ''
    };
  }

  function buildGtmAddToCartEvent(itemsAdded, currency = 'USD') {
    if (!Array.isArray(itemsAdded) || !itemsAdded.length) {
      console.error('[GTM] buildGtmAddToCartEvent: itemsAdded empty →', itemsAdded);
      return null;
    }

    return {
      event: 'add_to_cart',
      ecommerce: {
        currency,
        items: itemsAdded.map(mapAddedLineToGtmItem)
      }
    };
  }

  window.gtmUtils = {
    mapCartLineToGtmItem,
    mapRemovedLineToGtmItem,
    buildGtmEcommerceEvent,
    buildGtmCartEvent,
    buildGtmRemoveFromCartEvent,
    buildGtmAddToCartEvent,
    pushToDataLayer,
  };
})();
